import cx from "classnames";
import Item from "./Item";
import styles from "./Exhibitions.module.scss";
import HorizontalMenu from "./Menu/HorizontalMenu";
import { useState } from "react";
import Dropdown from "./Menu/Dropdown";
import { useTranslationContext } from "@providers/TranslationProvider";
import _ from "lodash";

export default function Exhibitions({ data }: any) {
  const { i18n } = useTranslationContext();
  const [items, setItems] = useState<any[]>(data.currentExhibition);
  const handleMenuChange = (value: any) => {
    setItems(data[value]);
  };
  const [selectValue, $selectValue] = useState("currentExhibition");
  const tabs = JSON.parse(i18n.t("Arts.exhibitions.tabs"));
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.wrapper)}>
        <div className={cx(styles.titleSection)}>{_.get(data, "title")}</div>
        <div className={cx(styles.descSection)}>
          {_.get(data, "description")}
        </div>
        <div className={cx(styles.menuDesktop)}>
          <HorizontalMenu items={tabs} value="" onChange={handleMenuChange} />
        </div>
        <div className={cx(styles.menuMobile)}>
          <Dropdown
            className={styles.hotels}
            itemProps={{ className: styles.label }}
            value={selectValue}
            onChange={(opt: any) => {
              $selectValue(opt?.value);
              handleMenuChange(opt?.value);
            }}
            options={tabs}
          />
        </div>
        <div className={cx(styles.wrapperItems)}>
          {items.map((item, index) => (
            <Item key={index} data={item} />
          ))}
        </div>
      </div>
    </div>
  );
}
